import React from 'react';
import Ship2Rail from 'components/Rail/Ship2Rail';
import CustomerForm from 'components/CustomerForm';

const RailFlow = ({ step, initialValues }) => {

  return (
    <>
      <>{step == 1 && (<Ship2Rail />)}</>
      <>{step == 2 && (<CustomerForm initialValues={initialValues} />)}</>
    </>
  );
};

export default RailFlow;